import styled from '@emotion/styled';
import { Button } from '@material-ui/core';

export const ExportActionMenuButton = styled(Button)`
  color: #555;
  .MuiSvgIcon-root {
    width: auto;
    padding: 2px 0;
  }
`;
